import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";
import { UserAutocompleteItem } from "../../../service/api-response/UsersAutocompleteSuccessResponse";

export const AUTOCOMPLETE_USERS_POPUP_SUCCESS =
  "COMMON:AUTOCOMPLETE_USERS_POPUP_SUCCESS";

export interface AutocompleteUsersPopupSuccessAction extends Action {
  type: typeof AUTOCOMPLETE_USERS_POPUP_SUCCESS;
  organization: OrganizationKeyName;
  users: UserAutocompleteItem[];
}

export const autocompleteUsersPopupSuccessAction = (
  organization: OrganizationKeyName,
  users: UserAutocompleteItem[]
): AutocompleteUsersPopupSuccessAction => ({
  type: AUTOCOMPLETE_USERS_POPUP_SUCCESS,
  organization,
  users,
});
